import { render } from "./Details.vue?vue&type=template&id=e4d3ea12&scoped=true"
const script = {}

import "./Details.vue?vue&type=style&index=0&id=e4d3ea12&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Zayd\\Documents\\Web Development\\Clients Projects\\RHDesigns\\rhdesigns-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4d3ea12"]])

export default __exports__